import _Vue from 'vue'
import store from '@/store'
import { User } from '@/api/Auth/auth.interface'

export enum Roles {
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  EMPLOYEE = 'EMPLOYEE',
  WHOLESALER = 'WHOLESALER',
  ACCOUNTANT = 'ACCOUNTANT',
  INGETRATION = 'INTEGRATION',
  INTEGRATION = 'INTEGRATION',
}

function isRole(role: string) {
  return (store.state.profile as User)?.role === role
}

export const profilePermissions = () => {
  return {
    get isAdmin() {
      return isRole(Roles.ADMIN)
    },
    get isAgent() {
      return isRole(Roles.AGENT)
    },
    get isEmployee() {
      return isRole(Roles.EMPLOYEE)
    },
    get isWholesaler() {
      return isRole(Roles.WHOLESALER)
    },
    get isAccountant() {
      return isRole(Roles.ACCOUNTANT)
    },
    get isIntegration() {
      return isRole(Roles.INGETRATION)
    },
    get isSuperuser() {
      return store.state.profile?.is_superuser
    },
    get canSeePayments() {
      return ['JOSEMLCMLC'].includes(store.state.profile?.username || '')
    },
    get canConfirmPayments() {
      return ['JOSEMLCMLC'].includes(store.state.profile?.username || '')
    },
    get isMaikel() {
      return store.state.profile?.username === 'maikel'
    },
    get canManageTransferTopups() {
      return (store.state.profile as User & {
        user_permissions: string[]
      })?.user_permissions.includes('can_manage_transfer_topups')
    },
    get canProcessMLCRemittances() {
      return (store.state.profile as User & {
        user_permissions: string[]
      })?.user_permissions.includes('can_process_mlc_remittances')
    },
  }
}

export default {
  install: (Vue: typeof _Vue) => {
    Vue.prototype.$p = profilePermissions()
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $p: ReturnType<typeof profilePermissions>
  }
}
